import { render, staticRenderFns } from "./NotificationMessage.vue?vue&type=template&id=4fb3d74c"
import script from "./NotificationMessage.vue?vue&type=script&lang=js"
export * from "./NotificationMessage.vue?vue&type=script&lang=js"
import style0 from "./NotificationMessage.vue?vue&type=style&index=0&id=4fb3d74c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports